import { render } from "./archiveButton.vue?vue&type=template&id=5516ed08&scoped=true"
import script from "./archiveButton.vue?vue&type=script&lang=js"
export * from "./archiveButton.vue?vue&type=script&lang=js"

import "./archiveButton.vue?vue&type=style&index=0&id=5516ed08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5516ed08"]])

export default __exports__